exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".moor-switch[data-v-38e00f2a]{display:inline-block}.moor-switch span div[data-v-38e00f2a]{float:left}.moor-switch input[data-v-38e00f2a]{display:none}.switch-box[data-v-38e00f2a]{width:40px;height:20px;background-color:#13ce66;border-radius:10px;display:flex;align-items:center;padding:0 2px;box-sizing:border-box;position:relative;cursor:pointer;margin-left:6px}.switch-box .closed[data-v-38e00f2a]{background-color:#ff4949}.switch-box span[data-v-38e00f2a]{width:16px;height:16px;border-radius:50%;display:inline-block;background-color:#fff;position:absolute;left:22px;transition:.2s}.switch-box .closed[data-v-38e00f2a]{left:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38e00f2a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/switch/switch.vue
// module id = 5
// module chunks = 0